"use client";
import Link from "next/link";
import React, { useState } from "react";
import Icon from "../primitives/icon";

interface StateObj {
  label: String,
  slug: URL,
  id: Number,
  legal: Boolean
}

interface StatesDropdownProps {
  label: String;
  states: StateObj[];
}

export default function StatesDropdown({ label, states }: StatesDropdownProps) {
  let [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <a
        className="block text-secondary-100 uppercase cursor-pointer"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >{label} <Icon className="ml-1 align-middle" name="caret-down" size="xs"></Icon></a>
      {isOpen &&
        <div className="pl-6">
          {states.map((state: StateObj) => (
            <Link className="block text-secondary-100 uppercase" href={state.slug}>{state.label}</Link>
          ))}
        </div>
      }
    </>
  );
}
